import { useEffect } from 'react';
import type { ReactElement } from 'react';
import { Button } from '../ui/Button';
import { Menu, MenuItem } from '../ui/Menu';
import { useExport, type ExportStatus } from './useExport';

/** PDF, and CSV of the whole dataset or of one table; the editor toolbar mounts it. */
export function ExportMenu(props: {
  reportId: string;
  tables: Array<{ id: string; title: string }>;
  /** Every change of the export's status, so the screen can show failures and announce downloads. */
  onStatus?(status: ExportStatus): void;
}): ReactElement {
  const { status, exportPdf, exportCsv } = useExport(props.reportId);
  const { onStatus } = props;
  useEffect(() => {
    if (status.kind !== 'idle') onStatus?.(status);
  }, [status, onStatus]);
  const trigger = (
    <Button variant="primary" busy={status.kind === 'working'} busyLabel="Exporting…">
      Export
    </Button>
  );
  return (
    <Menu label="Export" trigger={trigger}>
      <MenuItem id="pdf" onAction={() => void exportPdf()}>
        Download PDF
      </MenuItem>
      <MenuItem id="csv-dataset" onAction={() => void exportCsv({ kind: 'dataset' })}>
        Download CSV: whole dataset
      </MenuItem>
      {props.tables.map((t) => (
        <MenuItem key={t.id} id={`csv-${t.id}`} onAction={() => void exportCsv({ kind: 'table', widgetId: t.id })}>
          {`Download CSV: ${t.title}`}
        </MenuItem>
      ))}
    </Menu>
  );
}
